import { render, staticRenderFns } from "./AreaAppealListPanel.vue?vue&type=template&id=b8e26dde&scoped=true"
import script from "./AreaAppealListPanel.vue?vue&type=script&lang=js"
export * from "./AreaAppealListPanel.vue?vue&type=script&lang=js"
import style0 from "./AreaAppealListPanel.vue?vue&type=style&index=0&id=b8e26dde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e26dde",
  null
  
)

export default component.exports